// La costura se cose al entrar cada sección en pantalla. Una sola idea de
// movimiento; el resto de la página está quieta.
document.documentElement.classList.add('js');

const sheets = document.querySelectorAll('.sheet');

if (!window.IntersectionObserver) {
  sheets.forEach((s) => s.classList.add('is-sewn'));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-sewn');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  );
  sheets.forEach((s) => observer.observe(s));
}

// Menú móvil con <dialog>: foco atrapado y Escape gratis, del navegador.
const menu = document.querySelector('[data-menu]');
document.querySelector('[data-menu-open]')?.addEventListener('click', () => menu?.showModal());
document.querySelector('[data-menu-close]')?.addEventListener('click', () => menu?.close());
menu?.addEventListener('click', (e) => { if (e.target === menu) menu.close(); });

// Vistos recientemente: lista local de handles, sin cookies ni servidor.
try {
  const KEY = 'cotonna-vistos';
  const seen = JSON.parse(localStorage.getItem(KEY) || '[]');
  const here = document.querySelector('[data-product-handle]')?.dataset.productHandle;
  if (here) {
    const next = [here, ...seen.filter((h) => h !== here)].slice(0, 9);
    localStorage.setItem(KEY, JSON.stringify(next));
  }
  const rvHost = document.querySelector('[data-recently-viewed]');
  if (rvHost) {
    const show = seen.filter((h) => h !== here).slice(0, 4);
    if (!show.length) { rvHost.closest('.sheet')?.remove(); }
    else {
      Promise.all(show.map((h) =>
        fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)
      )).then((items) => {
        const ok = items.filter(Boolean);
        if (!ok.length) { rvHost.closest('.sheet')?.remove(); return; }
        rvHost.innerHTML = ok.map((p) => `
          <li class="card">
            <a href="${p.url}">
              <img src="${p.featured_image}&width=500" alt="" loading="lazy" width="500" height="500">
              <p class="card__type mark">${p.type || ''}</p>
              <h3 class="card__title">${p.title}</h3>
              <p class="card__price">${(p.price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
            </a>
          </li>`).join('');
      });
    }
  }
} catch (e) { /* localStorage bloqueado: la sección simplemente no sale */ }

// Relacionados: la API de recomendaciones nativa de Shopify, sin apps.
const rel = document.querySelector('[data-related]');
if (rel) {
  const pid = rel.dataset.related;
  fetch(`${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${pid}&limit=4&intent=related`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      const items = data?.products || [];
      if (!items.length) { rel.closest('.sheet')?.remove(); return; }
      rel.innerHTML = items.map((p) => `
        <li class="card">
          <a href="${p.url}">
            <img src="${p.featured_image}&width=500" alt="" loading="lazy" width="500" height="500">
            <p class="card__type mark">${p.type || ''}</p>
            <h3 class="card__title">${p.title}</h3>
            <p class="card__price">${(p.price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</p>
          </a>
        </li>`).join('');
    })
    .catch(() => rel.closest('.sheet')?.remove());
}

// Tira de miniaturas: los botones sólo aparecen si de verdad hay que desplazar.
// La miniatura activa se centra sola al cambiar de imagen, venga el cambio de
// las flechas, del teclado o del selector de color.
function centerThumb(radio) {
  const item = radio?.closest('.gal')?.querySelector(`label[for="${radio.id}"]`)?.closest('li');
  const strip = item?.closest('[data-thumbs]');
  if (!item || !strip) return;
  strip.scrollTo({ left: item.offsetLeft - (strip.clientWidth - item.clientWidth) / 2, behavior: 'smooth' });
}

document.querySelectorAll('.gal__strip').forEach((strip) => {
  const thumbs = strip.querySelector('[data-thumbs]');
  const prev = strip.querySelector('[data-thumbs-prev]');
  const next = strip.querySelector('[data-thumbs-next]');
  if (!thumbs || !prev || !next) return;

  const sync = () => {
    const scrollable = thumbs.scrollWidth - thumbs.clientWidth > 1;
    prev.hidden = !scrollable;
    next.hidden = !scrollable;
    if (!scrollable) return;
    prev.disabled = thumbs.scrollLeft <= 1;
    next.disabled = thumbs.scrollLeft >= thumbs.scrollWidth - thumbs.clientWidth - 1;
  };

  const page = (dir) => thumbs.scrollBy({ left: dir * thumbs.clientWidth * 0.8, behavior: 'smooth' });
  prev.addEventListener('click', () => page(-1));
  next.addEventListener('click', () => page(1));
  thumbs.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
});

document.addEventListener('change', (event) => {
  const radio = event.target.closest('.gal__radio');
  if (radio) centerThumb(radio);
});

// Barra de compra pegajosa: se enseña cuando el botón real deja de verse.
// El botón vive fuera del formulario y lo envía con el atributo `form`.
const stickybuy = document.querySelector('[data-stickybuy]');
const realButton = document.querySelector('[data-submit]');

if (stickybuy && realButton && window.IntersectionObserver) {
  new IntersectionObserver(
    ([entry]) => {
      // Sólo por debajo: al llegar al pie de página estorba menos que ayuda.
      const belowViewport = entry.boundingClientRect.top > 0;
      stickybuy.hidden = entry.isIntersecting || belowViewport;
    },
    { threshold: 0 }
  ).observe(realButton);
}

// Si el sistema pide menos movimiento, el bucle de vídeo se queda quieto en su
// primer fotograma. CSS no puede parar un autoplay; esto sí.
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('video[autoplay]').forEach((v) => {
    v.autoplay = false;
    v.removeAttribute('autoplay');
    v.pause();
  });
}

// Selector de color: refresca precio y disponibilidad. El <select name="id">
// ya basta para el carrito; esto sólo pinta.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variants]');
  if (!select) return;

  const form = select.closest('form');
  const option = select.selectedOptions[0];
  if (!form || !option) return;

  const price = form.querySelector('[data-price]');
  if (price) price.innerHTML = option.dataset.price;

  // Si la variante tiene su propia imagen, la galería salta a ella.
  const mid = option.dataset.mediaId;
  if (mid) {
    const radio = document.querySelector(`.gal__radio[data-media-id="${mid}"]`);
    if (radio) {
      radio.checked = true;
      centerThumb(radio);
    }
  }

  const submit = form.querySelector('[data-submit]');
  if (submit) {
    const sold = option.dataset.available !== 'true';
    submit.disabled = sold;
    submit.textContent = sold ? submit.dataset.soldText : submit.dataset.addText;
  }
});
